var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 241",
    d: "M14.5 0A14.5 14.5 0 1029 14.5 14.492 14.492 0 0014.5 0zm0 26.734A12.234 12.234 0 1126.734 14.5 12.227 12.227 0 0114.5 26.734z",
    fill: "#95989a"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 242",
    d: "M14.5 7.3a1.133 1.133 0 00-1.133 1.133v7.29a1.133 1.133 0 102.266 0v-7.29A1.133 1.133 0 0014.5 7.3z",
    fill: "#95989a"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 25",
    cx: 1.529,
    cy: 1.529,
    fill: "#95989a",
    r: 1.529,
    transform: "translate(12.971 18.247)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.98b3520522407f181c5c48d682a99bd3.svg";
export { ForwardRef as ReactComponent };